import { PropTypes } from 'prop-types';
import React from 'react';

import { getFormattedDate } from '../../../utils';
import Link from '../../Link';
import TitleLabel from '../../Titles/TitleLabel';

const CardTextBasedXSmallVariant = ({ date: _date, slug, tags, title }) => {
  const date = getFormattedDate(_date);
  return (
    <Link
      className="flex flex-col py-8 border-b lg:py-6 border-smoke lg:flex-col-reverse text-hover"
      to={`/article/${slug}/`}
    >
      <h5 className="stink-h5 lg:mt-2">{title}</h5>
      <div className="flex mt-2 lg:justify-between lg:mt-0 ">
        <div className="hidden lg:block">
          <TitleLabel tags={tags} />
        </div>
        {date && <p className="stink-footnote text-slate">{date}</p>}
      </div>
    </Link>
  );
};

CardTextBasedXSmallVariant.propTypes = {
  date: PropTypes.string,
  slug: PropTypes.string,
  tags: PropTypes.array,
  title: PropTypes.string,
};

export default CardTextBasedXSmallVariant;
